import { useEffect } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'
import { CentreFormationSidebar } from '@/components/dashboard/CentreFormationSidebar'
import { useAuth } from '@/lib/hooks/useAuth'

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass-card p-8 flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-success/30 border-t-success rounded-full animate-spin" />
        <p className="text-text-secondary text-sm">Chargement…</p>
      </div>
    </div>
  )
}

export default function CentreFormationLayout() {
  const { user, loading, logout } = useAuth('COMPANY')
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && user && user.companyType !== 'TRAINING_CENTER') {
      navigate('/dashboard', { replace: true })
    }
  }, [loading, user, navigate])

  if (loading) return <Spinner />
  if (!user || user.companyType !== 'TRAINING_CENTER') return null

  return (
    <div className="min-h-screen flex">
      <CentreFormationSidebar user={user} onLogout={logout} />
      <div className="flex-1 ml-60 min-h-screen flex flex-col">
        <main className="flex-1 p-8">
          <div className="max-w-3xl mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
